import { render, staticRenderFns } from "./ApiSimpleSearch.vue?vue&type=template&id=06d936e1"
import script from "./ApiSimpleSearch.vue?vue&type=script&lang=js"
export * from "./ApiSimpleSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports